/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyClickUpIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-clickup" */ './utils').then((m) => m.ClickUpIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/clickup/icon' },
);

const LazyClickUpSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-clickup-search-result" */ './utils').then(
			(m) => m.ClickUpSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/clickup/search-result-icon' },
);

const LazyClickUpIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-clickup-borderless" */ './utils').then(
			(m) => m.ClickUpIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/clickup/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ClickUpIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyClickUpIconComponent />
	</Suspense>
);

export const ClickUpSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyClickUpSearchResultIconComponent />
	</Suspense>
);

export const ClickUpIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyClickUpIconBorderlessComponent />
	</Suspense>
);
